export const SETTLEMENT_APPROVAL_BUTTON_LABEL = 'Aprobar y enviar'